import { render, staticRenderFns } from "./ChatConfirm.vue?vue&type=template&id=5dfff848&scoped=true"
import script from "./ChatConfirm.vue?vue&type=script&lang=js"
export * from "./ChatConfirm.vue?vue&type=script&lang=js"
import style0 from "./ChatConfirm.vue?vue&type=style&index=0&id=5dfff848&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfff848",
  null
  
)

export default component.exports